import { render, staticRenderFns } from "./PropertyTypes.vue?vue&type=template&id=19612612"
import script from "./PropertyTypes.vue?vue&type=script&lang=js"
export * from "./PropertyTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports